const CommentDead = () => {
  return <p className="dead">Dead Comment</p>;
}
 
export default CommentDead;